import { useState, useEffect } from 'react'
import { CreditPoints } from 'services/CreditPoints'

export function usePoints(props){
    const {
        cardending
    } = props

    const [respPoints, setRespPoints] = useState()
    const [points, setPoints] = useState()
    const [cardE, setcardE] = useState()

    useEffect(()=>{
        if(cardE){
            CreditPoints(cardE)
            .then(setRespPoints)
        }
    },[cardE, cardending])

    useEffect(()=>{
        if(respPoints){
            setPoints(respPoints?.data[0]?.available_points)
        }
    },[respPoints])

    const setCardEnding = (val) => {
        let carending = String(val)
        setcardE(carending)
    }

    return{
        points,
        setCardEnding
    }
}